/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoriesOutDetailsQuery } from '../../models/get-inventories-out-details-query';
import { GetInventoriesOutDetailsQueryResult } from '../../models/get-inventories-out-details-query-result';

export interface ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Params {
      body?: GetInventoriesOutDetailsQuery
}

export function apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoriesOutDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoriesOutDetailsQueryResult>;
    })
  );
}

apiNurseryManagerInventoryOutGetInventoriesDetailsOutPost$Plain.PATH = '/api/NurseryManager/InventoryOut/GetInventoriesDetailsOut';
